import React from 'react';

import { IconButton } from '@mui/material';
import clsx from 'clsx';

import { CloseIcon } from '@components/icons';

import type { CloseButtonXProperties } from './CloseButtonX.types';

export const CloseButtonX: React.FC<CloseButtonXProperties> = ({
  onClick,
  color,
  className,
  disabled,
  dataTest = 'close_button',
}) => {
  const closeButtonClasses = clsx('m-1', 'ms-0', className);
  const handleClick = React.useCallback(() => {
    onClick?.();
  }, [onClick]);
  return (
    <IconButton
      data-testid={dataTest}
      onClick={handleClick}
      className={closeButtonClasses}
      color={color}
      disabled={disabled}
      sx={{ padding: 0, mr: 2.5 }}
      size='large'
    >
      <CloseIcon sx={{ color: 'text.primary' }} />
    </IconButton>
  );
};
